/*
Notification link: https://www.npmjs.com/package/react-notifications

NOTE: 
1. Use effect for search customer
https://www.udemy.com/course/react-the-complete-guide-incl-redux/learn/lecture/25599220#overview

2. async/await => Promise
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function
*/
/** Order and Measurements */

import {
  Fragment,
  useState,
  useEffect,
  useRef,
  createRef,
  forwardRef,
} from "react";
import customerServices from "../../services/customerServices";
import measurementServices from "../../services/measurementServices";
import _orderDetailService from "../../services/orderDetailServices";
import _orderService from "../../services/orderServices";
import commonServices from "../../Utils/commonServices";
// React Notification
import { NotificationManager } from "react-notifications";
import ShowSingleMeasurement from "../Measurement/ShowSingleMeasurement";
import OrderDetailInformationAddEditOrView from "./OrderDetailInformationAddEditOrView";
import DDLmeasurementSettings from "../Measurement/DDLmeasurementSettings";
import { string } from "yup";
// import SingleMeasurement_Final from "./../Measurement/SingleMeasurement_Final";
import AddEditSingleMeasurementOnOrderPage from "./../Measurement/AddEditSingleMeasurementOnOrderPage";
import vmOrderAddEdit from "./../../Models/vmOrderAddEdit";
import measurementSettingsDetailsServices from "../../services/measurementSettingsDetailsServices";
import vmOrderDetail from "./../../Models/vmOrderDetail";
import uuid from "react-native-uuid";
//** get actions from store */
import { useSelector, useDispatch } from "react-redux";
import OrderMakingPrint from "./../Order/OrderMakingPrint";
import {
  clearOrderProductItemStore,
  assignOrderProductItemListStore,
  addOrderProductItemStoreAtBottom,
  removeOrderProductItemStore,
  //** */
  clearOrder,
  clearOrderItemDetailStore,
  updateOrderInfoModeStore,
  addOrderItemDetailStore,
  addOrderItemDetailStoreAtBottom,
  removeOrderItemDetailStore,
  addOrderItemWithMeasurementsStore,
  removeOrderItemWithMeasurementsStore,
  addOrderItemUniqueStore,
  removeOrderItemUniqueStore,
  updateViewModeOrderItemDetailStore,
  add_orderItemDetailStore_singleValue_ForCopy,
  clear_orderItemDetailStore_singleValue_ForCopy,
} from "./../../slice/orderSlice";
import ReactToPrint from "react-to-print";
import { useAuth } from "./../../store/auth-context";

const AddCustomerOrder = (props) => {
  const printableRef_MeasurementAllItem = useRef(null);

  //Copy Item from AuthContext
  const { setCopyItemState, isCoppiedItem } = useAuth();
  // alert(isCoppiedItem);
  //*** Store */
  const dispatch = useDispatch();
  //Get state from store
  const {
    customerStore,
    customerInfoModeStore,
    customerGUIDStore,
    orderStore,
    orderInfoModeStore,
    orderGUIDStore,
    orderProductItemStore,
    orderItemDetailStore, // This list id used in this page.
    orderItemDetailStoreForPrint,
    orderItemsWithMeasurementStore,
    orderItemsUniqueStore,
    isLoadingStore,
    orderItemDetailStore_singleValue_ForCopy,
  } = useSelector((state) => state.order);

  const [orderParent, setOrderParent] = useState(new vmOrderAddEdit());
  const [listOrderDetail, setListOrderDetail] = useState([]);

  //*** Paste Item */
  const [showPasteItemButton, setShowPasteItemButton] = useState(false);

  // customerGUID
  const [selectedMeasurementSettings, setSelectedMeasurementSettings] =
    useState(0);
  const [selectedMeasurementSettingsName, setSelectedMeasurementSettingsName] =
    useState("");
  const [selectedProductItemGUID, setSelectedProductItemGUID] = useState("");
  const [selectedProductItemName, setSelectedProductItemName] = useState("");
  const [
    selectedProductItemMackingCharge,
    setSelectedProductItemMackingCharge,
  ] = useState("");
  const [showAddEditSingle, setShowAddEditSingle] = useState(false);

  // (1) Load Single Order - all Measurement and Detail
  const [singleOrderMeasurements, setSingleOrderMeasurements] = useState([]);
  const [singleOrderMeasurementsUnique, setSingleOrderMeasurementsUnique] =
    useState([]);
  // const [orderMeasurementStatus, setOrderMeasurementStatus] =
  //   useState < { measurementGUID: string, status: string } > [];

  //add edit decision
  const [orderGUIDAfterSave, setOrderGUID] = useState("");
  const [isAddEditOrViewMode, setIsAddEditOrViewMode] = useState(false);

  //** Load Order Pruduct Items for Invoice */
  const LoadProductItemByOrderGUIDForInvoice = async (orderGUID) => {
    dispatch(clearOrderProductItemStore());
    //// alert("LoadProductItemByOrderGUID: " + orderGUID);
    let orderedProductItemSearched =
      await _orderService.GetOrderItemWithCommentByOrderGUID(orderGUID);
    // alert(
    //   "orderedProductItemSearched ++ : " + orderedProductItemSearched.length
    // );
    if (
      orderedProductItemSearched !== null &&
      orderedProductItemSearched !== undefined &&
      orderedProductItemSearched.length > 0
    ) {
      // alert(
      //   "orderedProductItemSearched -- : " + orderedProductItemSearched.length
      // );
      dispatch(assignOrderProductItemListStore(orderedProductItemSearched));
    } else {
      dispatch(assignOrderProductItemListStore([]));
    }
  };

  const LoadSingleOrderMeasurementByOrderGUID = async (orderGUID) => {
    dispatch(clearOrderItemDetailStore());
    //// alert("LoadSingleOrderMeasurementByOrderGUID: " + orderGUID);
    let orderMeasurementsSearched =
      await measurementServices.MeasurementDetailByOrderGUID(orderGUID);
    // alert("orderMeasurementsSearched++ : " + orderMeasurementsSearched.length);

    if (
      orderMeasurementsSearched !== null &&
      orderMeasurementsSearched !== undefined &&
      orderMeasurementsSearched.length > 0
    ) {
      // setSingleOrderMeasurements(orderMeasurementsSearched);
      //get unique Order-Detail
      let singleOrderMeasurementsUniqueTemp = commonServices.uniqueOfArray(
        orderMeasurementsSearched,
        "orderDetailID_GUID"
      );

      // alert(
      //   "singleOrderMeasurementsUniqueTemp -- : " +
      //     singleOrderMeasurementsUniqueTemp.length
      // );

      if (
        singleOrderMeasurementsUniqueTemp !== null &&
        singleOrderMeasurementsUniqueTemp !== undefined &&
        singleOrderMeasurementsUniqueTemp.length > 0
      ) {
        setSingleOrderMeasurementsUnique(singleOrderMeasurementsUniqueTemp);
        //*** set at object here */
        // singleOrderMeasurementsUnique

        // alert(
        //   "singleOrderMeasurementsUniqueTemp: " +
        //     singleOrderMeasurementsUniqueTemp.length
        // );

        // alert("orderMeasurementsSearched: " + orderMeasurementsSearched.length);

        singleOrderMeasurementsUniqueTemp.map((measurementDetail, i) => {
          let lstMeasurementDetailTemp = orderMeasurementsSearched.filter(
            (o) => o.orderDetailID_GUID === measurementDetail.orderDetailID_GUID
          );

          // alert(
          //   "lstMeasurementDetailTemp>>> : " +
          //     JSON.stringify(lstMeasurementDetailTemp)
          // );

          // debugger;

          // child object - Order detail
          let orderDetail = new vmOrderDetail();
          orderDetail.indexNo = uuid.v4();
          orderDetail.orderDetailID_GUID = measurementDetail.orderDetailID_GUID;

          // alert(
          //   "orderDetail.qty : - " +
          //     orderDetail.qty +
          //     ", " +
          //     orderDetail.lstMeasurementDetails.length
          // );

          //a
          orderDetail.lstMeasurementDetails.push.apply(
            orderDetail.lstMeasurementDetails,
            lstMeasurementDetailTemp
          );

          //b
          setListOrderDetail((prevValue) => [orderDetail, ...prevValue]);

          // alert(
          //   "orderDetail.lstMeasurementDetails :: added " +
          //     orderDetail.lstMeasurementDetails.length
          // );
          //Parent obj - Order
          console.log("orderDetail - strong" + orderDetail);
          orderParent.lstOrderDetail.push(orderDetail);
          // dispatch(clearOrderItemDetailStore());
          dispatch(addOrderItemDetailStoreAtBottom(orderDetail));
        });
      } else {
        setSingleOrderMeasurementsUnique([]);
      }
    } else {
      setSingleOrderMeasurements([]);
      setSingleOrderMeasurementsUnique([]);
    }
  };

  //** remove measurement component */
  const removeMeasurementCoponent = (index) => {};

  // add new Item measurement
  const AddNewMeasurement = () => {
    if (selectedMeasurementSettings === 0) {
      // alert("selectedMeasurementSettings -->>> " + selectedMeasurementSettings);

      NotificationManager.warning("Please select an item", "Warning", 4000);
      return;
    }
    // alert("selectedMeasurementSettings: " + selectedMeasurementSettings);
    fetchMeasurementSettings(selectedMeasurementSettings);
  };

  // Paste Copy Item
  const Paste_CopyItem = () => {
    const copy = JSON.parse(localStorage.getItem("copy_Item"));
    console.log("localSto rage.getItem(copy_Item) :: ", copy);

    if (copy !== null) {
      copy.entyOrView = 1;
      copy.orderDetailID_GUID = "";

      orderParent.lstOrderDetail.push(copy);
      setListOrderDetail((prevValue) => [copy, ...prevValue]);
      dispatch(addOrderItemDetailStoreAtBottom(copy));

      //clear
      localStorage.removeItem("copy_Item");
      setCopyItemState(false);

      //Broadcast false event of Copy Item / Paste Item

      //copy item - broadcast.
      const channel = new BroadcastChannel("channel_copyItem");
      let data = false;
      channel.postMessage(data);

      //Notification
      NotificationManager.success(
        "Paste item successfully",
        "Successful!",
        4000
      );
    }
  };

  // useEffect(() => {
  //   // alert("reload" + isCoppiedItem);
  //   setShowPasteItemButton(isCoppiedItem);
  // }, [isCoppiedItem]);

  useEffect(() => {
    //NOTE: copy work
    //alert("start edit " + orderItemDetailStore.length);
    const newArray = orderItemDetailStore.map((orderDetail, i) => {
      if (props.isCopy) {
        orderDetail.entyOrView = 2;
        return orderDetail;
      }
    });
  }, [orderItemDetailStore]);

  useEffect(() => {
    const handleStorageChange = () => {
      const data = JSON.parse(localStorage.getItem("isCopyItemExist"));
      // Do something with the received data
      // alert(data);
    };

    // //NOTE: copy work
    // alert("start edit");
    // const newArray = orderItemDetailStore.map((orderDetail, i) => {
    //   alert("dddd");
    //   if (props.isCopy) {
    //     alert("edit...");
    //     orderDetail.entyOrView = 2;
    //     return orderDetail;
    //   }
    // });

    window.addEventListener("storage", handleStorageChange);

    //Receive broad cast
    const channel = new BroadcastChannel("channel_copyItem");
    channel.onmessage = (event) => {
      const data = event.data;
      // Do something with the received data
      if (data === true) {
        setCopyItemState(true);
      } else {
        setCopyItemState(false);
      }

      //alert("received data" + data);
    };

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // useEffect(() => {
  //   //order == addNew
  //   if (props.orderGUID === "") {
  //     dispatch(clearOrder());
  //     dispatch(clearOrderProductItemStore());
  //     dispatch(updateOrderInfoModeStore(1));
  //   }

  //   LoadProductItemByOrderGUIDForInvoice(props.orderGUID);
  //   LoadSingleOrderMeasurementByOrderGUID(props.orderGUID);
  //   // below added inside component "OrderMakingPrint.js"
  //   // orderItemDetailStoreForPrint - Print...
  //   // dispatch(assignOrderItemDetailStoreForPrint(orderItemDetailStore));
  // }, [props.orderGUID]);

  useEffect(() => {
    // a. check already some thing in copy Item localstorage.
    const copy = JSON.parse(localStorage.getItem("copy_Item"));
    // alert("localSto rage.getItem(copy_Item) :: " + copy);
    if (copy !== null) {
      setCopyItemState(true);
    } else {
      setCopyItemState(false);
    }

    // alert("Load again....");
    //order == addNew
    // b.
    if (props.orderGUID === "") {
      dispatch(clearOrder());
      dispatch(clearOrderProductItemStore());
      dispatch(updateOrderInfoModeStore(1));
    }
    LoadProductItemByOrderGUIDForInvoice(props.orderGUID);
    LoadSingleOrderMeasurementByOrderGUID(props.orderGUID);
  }, []);

  //(a) Get all measurement settings by settings ID(item)
  const fetchMeasurementSettings = async (settingsID) => {
    try {
      // alert("called api");
      let measurementSettingsAll =
        await measurementSettingsDetailsServices.getBySettingsID(settingsID);

      // alert("called api done : " + measurementSettingsAll.length);

      console.log("measurementSettingsAll : " + measurementSettingsAll[0]);
      // setSettingsDetails(measurementSettingsAll);
      // console.log("settingsDetails : " + settingsDetails.length);

      // child object - Order detail
      let orderDetail = new vmOrderDetail();
      orderDetail.settingsID_GUID = settingsID;
      orderDetail.indexNo = uuid.v4();
      orderDetail.orderDetailID_GUID = "";
      orderDetail.entyOrView = 1; // insert mode
      orderDetail.lstMeasurementDetails = measurementSettingsAll;

      // alert(
      //   "orderDetail.lstMeasurementDetails :: added " +
      //     orderDetail.lstMeasurementDetails.length
      // );

      //  debugger;
      //Parent obj - Order
      orderParent.lstOrderDetail.push(orderDetail);
      setListOrderDetail((prevValue) => [orderDetail, ...prevValue]);
      dispatch(addOrderItemDetailStoreAtBottom(orderDetail));

      // alert(
      //   "orderParent.lstOrderDetail :: added => orderItemDetailStore " +
      //     orderParent.lstOrderDetail.length +
      //     ",,,," +
      //     orderItemDetailStore.length
      // );

      setOrderParent(orderParent);
    } catch (e) {
      console.error(e);
    }
  };

  const changeMode = async (indexNo, modeno) => {
    try {
      // alert("indexNo, modeno (Add Customer Order) :" + indexNo + ", " + modeno);
      // debugger;
      dispatch(
        updateViewModeOrderItemDetailStore({ indexNo: indexNo, modeno: modeno })
      );

      //** ducktap */
      // NOTE: for copy work
      // const newArray = orderItemDetailStore.map((orderDetail, i) => {
      //   if (orderDetail.indexNo !== indexNo) {
      //     // change Mode.
      //     orderDetail.entyOrView = modeno;
      //     return orderDetail;
      //   } else {
      //     // The rest haven't changed
      //     return orderDetail;
      //   }
      // });
      // orderParent.lstOrderDetail = newArray;
      // setOrderParent(orderParent);
    } catch (e) {
      console.error(e);
    }
  };

  const removeOrder = (orderID_GUID) => {
    // alert(
    // );
    if (orderID_GUID != "") {
      // ** (1) Delete from DB
      let result = _orderService.deleteByOrderGUID(orderID_GUID);
    }
    //** (2) Delete from State Store */
    dispatch(clearOrder());

    //Notification
    NotificationManager.success("Removed successfully", "Successful!", 4000);
  };
  //***    Remove measurements Item */
  async function confirmationOnDeleteClick() {
    const confirmation = window.confirm(
      "Are you sure you want to remove this?"
    );
    return confirmation;
  }

  async function confirmationOnCopyClick() {
    const confirmation = window.confirm("Are you sure you want to copy this?");
    return confirmation;
  }

  const removeOrderItem = (itemIndex, orderDetailID_GUID) => {
    confirmationOnDeleteClick()
      .then((concent) => {
        if (concent) {
          // alert(
          //   "itemIndex and orderDetailID_GUID :: at AddCustomerOrder component : " +
          //     itemIndex +
          //     ", " +
          //     orderDetailID_GUID
          // );

          if (orderDetailID_GUID != "") {
            // ** (1) Delete from DB
            let result =
              _orderDetailService.deleteByOrderDetailGUID(orderDetailID_GUID);
          }
          //** (2) Delete from State Store */
          dispatch(removeOrderItemDetailStore({ indexNo: itemIndex }));

          //Notification
          NotificationManager.success(
            "Removed successfully",
            "Successful!",
            4000
          );
        }
      })
      .catch((error) => {
        console.error("Promise rejected:", error);
      });
  };

  const Copy_OrderItem = (
    itemIndex,
    orderDetailID_GUID,
    productItemID_GUID
  ) => {
    confirmationOnCopyClick()
      .then((concent) => {
        if (concent) {
          // alert(
          //   "itemIndex and orderDetailID_GUID :: at AddCustomerOrder component : " +
          //     itemIndex +
          //     ", " +
          //     orderDetailID_GUID +
          //     " , " +
          //     productItemID_GUID
          // );

          if (orderDetailID_GUID != "") {
            //** (2) copy from State Store */
            let copy_orderItemDetailStore = orderItemDetailStore.filter(
              (item) => item.indexNo == itemIndex
            );

            console.log(
              "copy_orderItemDetailStore :: ",
              copy_orderItemDetailStore[0]
            );

            localStorage.setItem(
              "copy_Item",
              JSON.stringify(copy_orderItemDetailStore[0])
            );

            const copy = JSON.parse(localStorage.getItem("copy_Item"));
            console.log("localSto rage.getItem(copy_Item) :: ", copy);

            // Copy state keep in auth context to show/hide paste button
            setCopyItemState(true);

            //copy item - broadcast.
            const channel = new BroadcastChannel("channel_copyItem");
            let data = true;
            channel.postMessage(data);

            //Notification
            NotificationManager.success(
              "Copy successfully",
              "Successful!",
              4000
            );
          }
        }
      })
      .catch((error) => {
        console.error("Promise rejected:", error);
      });
  };

  // if (loading) return <h1> LOADING...</h1>;
  // if (error) console.log(error);

  //********************** add product measurement *************** */
  const onProductItemSelect = (
    selectedProductItemGIUD,
    selectedProductItemName,
    slectedID,
    selectedValue,
    makingCharge
  ) => {
    // alert(slectedID + ",vv " + selectedValue);
    setSelectedProductItemGUID(selectedProductItemGIUD);
    setSelectedMeasurementSettings(slectedID);
    setSelectedMeasurementSettingsName(selectedValue);
    setSelectedProductItemName(selectedProductItemName);
    setSelectedProductItemMackingCharge(makingCharge);
    // add button event
    fetchMeasurementSettings(slectedID); // stop on client request
  };

  //********************** END add product measurement *************** */

  const buttonStyle = {
    backgroundColor: "gray", // Change the background color to gray
    color: "white", // Change the text color to white
    cursor: "not-allowed", // Change the cursor to 'not-allowed'
  };

  const copyOrderMeasurement = () => {
    const win = window.open(
      "/Customer/" +
        customerStore.customerID_GUID +
        "/OrderCopy/" +
        orderStore.orderID_GUID,
      "_blank"
    );
    win.focus();
    // history.push("/Measurement/${customerGUID}");
  };

  return (
    <Fragment>
      {props.isCopy && (
        <div
          style={{
            backgroundColor: "coral",
            color: "white",
            padding: "5px",
            textAlign: "center",
          }}
        >
          Copy of Order Measurement
        </div>
      )}

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card ">
                    <div className="card-body card-body-padding-less">
                      {!props.isCopy && (
                        <div
                          style={{
                            float: "left",
                            marginLeft: "400px",
                          }}
                        >
                          <button
                            className="btn btn-primary px-3"
                            style={{ backgroundColor: "#008000" }}
                            id="newTab"
                            type="button"
                            disabled={false}
                            onClick={() => {
                              copyOrderMeasurement();
                            }}
                            // ref={ref}
                          >
                            <i className="fas fa-send-backward fa-fw"></i>
                            COPY ORDER MEASUREMENTS
                          </button>
                        </div>
                      )}
                      {/* printing Order Making */}.
                      <div style={{ float: "right", marginRight: "10px" }}>
                        <ReactToPrint
                          trigger={() => (
                            <button className="btn btn-primary px-3">
                              Print Order Measurement
                            </button>
                          )}
                          content={() =>
                            printableRef_MeasurementAllItem.current
                          }
                        />
                      </div>
                      {/* Measurement print work */}
                      <div style={{ display: "none" }}>
                        <div ref={printableRef_MeasurementAllItem}>
                          <OrderMakingPrint
                            customerStore={customerStore}
                            orderStore={orderStore}
                            orderItemDetailStoreProp={orderItemDetailStore}
                          />
                        </div>
                      </div>
                      {/* <div style={{ clear: "both" }}></div> */}
                      {/* <!-- Order Information --> */}
                      {/* <OrderDetailInformation orderGUID={props.orderGUID} /> */}
                      <OrderDetailInformationAddEditOrView
                        orderGUID={props.isCopy ? 0 : props.orderGUID}
                        customerGUID={props.customerGUID}
                        removeOrder={removeOrder}
                      />
                      <hr />
                      <div
                        className="divWithBgColor_ddl"
                        // style={{
                        //   backgroundColor: "lightgreen",
                        //   padding: "10px",
                        //   borderRadius: "0.625rem",
                        //   width: "100%",
                        // }}
                      >
                        <div style={{ float: "left" }}>
                          {" "}
                          <DDLmeasurementSettings
                            className="dropdown-add-measurement"
                            ddlOnSelectFunction={onProductItemSelect}
                          />
                        </div>
                        <div style={{ float: "left" }}>
                          {" "}
                          <button
                            style={true ? buttonStyle : {}}
                            disabled={true}
                            className="btn btn-primary px-3 ml-4"
                            onClick={AddNewMeasurement}
                          >
                            Add Item
                          </button>
                          {isCoppiedItem && (
                            <button
                              // style={true ? buttonStyle : {}}
                              disabled={false}
                              className="btn btn-primary px-3 ml-4"
                              onClick={Paste_CopyItem}
                            >
                              Paste Item
                            </button>
                          )}
                        </div>
                        <div style={{ clear: "both" }}></div>
                      </div>
                      <div style={{ clear: "both" }}></div>
                      <div className="read-content">
                        {/* New coding */}
                        {/* {listOrderDetail.map((orderDetail, i) => { */}
                        {orderItemDetailStore.map((orderDetail, i) => {
                          // debugger;
                          //NOTE: if View mode
                          if (orderDetail.entyOrView === 3) {
                            return (
                              <>
                                {"view............. "}
                                <ShowSingleMeasurement
                                  blockOrder={i * 100}
                                  mode={3}
                                  orderDetailProps={orderDetail}
                                  orderDetailID_GUID_props={
                                    orderDetail.orderDetailID_GUID
                                  }
                                  indexEntry={orderDetail.indexNo}
                                  lstMeasurementDetail={
                                    orderDetail.lstMeasurementDetails
                                  }
                                  changeMode={changeMode}
                                  removeOrderItem={removeOrderItem}
                                  Copy_OrderItem={Copy_OrderItem}
                                  customerStoreProps={customerStore}
                                  orderStoreProps={orderStore}
                                  orderProductItem={orderProductItemStore.filter(
                                    (o) =>
                                      o.orderDetailID_GUID ===
                                      orderDetail.orderDetailID_GUID
                                  )}
                                  entryEditOrViewMode={orderDetail.entyOrView}
                                />
                              </>
                            );
                          }
                          //NOTE: if Edit mode
                          else if (orderDetail.entyOrView === 2) {
                            return (
                              <>
                                {"edit.................www"}
                                <AddEditSingleMeasurementOnOrderPage
                                  blockOrder={i * 100}
                                  mode={1}
                                  orderDetailID_GUID_props={
                                    props.isCopy
                                      ? ""
                                      : orderDetail.orderDetailID_GUID
                                  }
                                  indexEntry={orderDetail.indexNo}
                                  lstMeasurementDetail={
                                    orderDetail.lstMeasurementDetails
                                  }
                                  settingsID={orderDetail.settingsID_GUID}
                                  changeMode={changeMode}
                                  removeOrderItem={removeOrderItem}
                                  makingCharge={
                                    selectedProductItemMackingCharge
                                  }
                                  orderProductItem={orderProductItemStore.filter(
                                    (o) =>
                                      o.orderDetailID_GUID ===
                                      orderDetail.orderDetailID_GUID
                                  )}
                                  entryEditOrViewMode={orderDetail.entyOrView}
                                />
                              </>
                            );
                          }
                          //NOTE: if Entry mode
                          else if (orderDetail.entyOrView === 1) {
                            return (
                              <>
                                {"Addd.................."}
                                <AddEditSingleMeasurementOnOrderPage
                                  blockOrder={i * 100}
                                  mode={1}
                                  orderDetailID_GUID_props={
                                    orderDetail.orderDetailID_GUID
                                  }
                                  indexEntry={orderDetail.indexNo}
                                  lstMeasurementDetail={
                                    orderDetail.lstMeasurementDetails
                                  }
                                  settingsID={orderDetail.settingsID_GUID}
                                  changeMode={changeMode}
                                  removeOrderItem={removeOrderItem}
                                  makingCharge={
                                    selectedProductItemMackingCharge
                                  }
                                  orderProductItem={orderProductItemStore.filter(
                                    (o) =>
                                      o.orderDetailID_GUID ===
                                      orderDetail.orderDetailID_GUID
                                  )}
                                  entryEditOrViewMode={orderDetail.entyOrView}
                                />
                              </>
                            );
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddCustomerOrder;
